import { jsx as _jsx } from "react/jsx-runtime";
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
import { useContext, useMemo } from 'react';
import { Control } from 'shared/components/fields/control';
import { StrictNumberInput } from 'shared/components/fields';
import { InputAdornment } from '@mui/material';
import { useHeatingCircuitsItemState } from 'z3k-settings/climatic/heating-circuits-item/lib/useHeatingCircuitsItemState';
import { parseFloatWithComma } from 'utils';
import { circuit_target_minmax } from 'console/climatic/setting-tabs/circuit/temperature-settings';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
import { HeatingMode } from 'z3k-config';
export function TargetTemperatureSettings() {
    const { target_temperatures, circuit, control_mode, water_min_temperature, water_max_temperature, } = useHeatingCircuitsItemState();
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    const [temp_min, temp_max] = useMemo(() => circuit_target_minmax(circuit.type, control_mode, parseFloatWithComma(water_min_temperature), parseFloatWithComma(water_max_temperature)), [circuit, control_mode, parseFloatWithComma, circuit_target_minmax]);
    const temperatures = useMemo(() => target_temperatures.map(([mode, target_temp], i) => {
        const onChangeTemperature = (value) => {
            const new_value = value > temp_max
                ? temp_max
                : value < temp_min
                    ? temp_min
                    : value;
            replace_config({
                ...config,
                heating_modes: config.heating_modes.map((item) => {
                    if (item.id === mode.id) {
                        return {
                            ...item,
                            heating_zones: item.heating_zones.map((zone) => {
                                if (zone.heating_circuit === circuit.id) {
                                    return {
                                        ...zone,
                                        temperature_setting: HeatingMode.makeTemperatureSetting(parseFloatWithComma(new_value)),
                                    };
                                }
                                return zone;
                            }),
                        };
                    }
                    return item;
                }),
            });
        };
        return (_jsx(Control, { label: mode.name, validation_result: Number(target_temp) > temp_max ||
                Number(target_temp) < temp_min
                ? `Допустимые значения: от ${temp_min} до ${temp_max} °C`
                : null, validation_warnings_result: null, value: target_temp, onChange: onChangeTemperature, field: (input_props) => (_jsx(StrictNumberInput, { ...input_props, min: temp_min, max: temp_max, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u00B0C" }) })) }, mode.id));
    }), [target_temperatures, temp_max, temp_min]);
    return (_jsx(SettingCard, { title: "\u0426\u0435\u043B\u0435\u0432\u0430\u044F \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0430 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F", children: temperatures }));
}
